import type { TDatadogErrorLog } from 'utils/datadog/types'

export const LOAD_DASHBOARD_FOLDERS_LOG: TDatadogErrorLog = {
  from: 'src/modules/dashboard/select-dashboard-folder-modal',
  name: 'Loads Dashboard Folders',
  message: 'Failed to load the Dashboard Folders list',
}

export const ADD_DASHBOARD_TO_FOLDER_LOG: TDatadogErrorLog = {
  from: 'src/modules/dashboard/select-dashboard-folder-modal',
  name: 'Adds dashboard to a folder',
  message: 'Failed to add a dashboard to a folder',
}

export const BASE_PAGE_SIZE = 10
